import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

const OurSolution = () => {
  useEffect(() => {
    AOS.init({
      once: false,
      duration: 800,
      easing: 'ease-out'
    });
  }, []);

  return (
   <section className="lg:py-28 lg:px-12 px-5 py-12 bg-bgDefault text-white">
      <div className="container mx-auto max-w-screen-xl">
        {/* Header */}


        {/* Content Container */}
        <div className="lg:px-[168px]">
          {/* Description */}
          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
            data-aos="fade-down"
          >
            What We Did & How We Did It
          </h2>

          {/* <h3 className="text-2xl lg:text-3xl font-semibold text-[#00E599] mb-4">What We Did & How We Did It</h3> */}

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            We developed a comprehensive, HIPAA-compliant mental health management platform using Java and Spring Boot
            for secure backend services, PostgreSQL for encrypted patient data storage, and React.js for an intuitive
            user interface. The platform was deployed on AWS S3 with CloudFront CDN for optimal performance, integrated
            with Twilio for video consultations, and implemented end-to-end encryption for all patient communications
            and medical records.
          </p>

          <h4
            className="text-xl font-semibold text-white mb-3"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            Core Features Delivered:
          </h4>
          <ul className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6 list-disc pl-5 space-y-2">
            <li data-aos="zoom-in" data-aos-delay="250"><strong>Digital Patient Management:</strong> Comprehensive patient profiles with medical history, treatment plans, session notes, and progress tracking across multiple providers</li>
            <li data-aos="zoom-in" data-aos-delay="300"><strong>Session Documentation System:</strong> Structured note-taking templates for therapists with voice-to-text capabilities, automated timestamp logging, and searchable archives</li>
            <li data-aos="zoom-in" data-aos-delay="350"><strong>E-Prescription Module:</strong> Integrated digital prescription system with pharmacy APIs, medication interaction warnings, and automated refill reminders</li>
            <li data-aos="zoom-in" data-aos-delay="400"><strong>Secure Teleconsultation:</strong> HIPAA-compliant video consultation platform with screen sharing, session recording (with consent), and in-session note-taking</li>
            <li data-aos="zoom-in" data-aos-delay="450"><strong>Appointment Scheduling:</strong> Intelligent calendar system with automated reminders, waitlist management, and recurring appointment support</li>
            <li data-aos="zoom-in" data-aos-delay="500"><strong>Patient Portal:</strong> Self-service portal for appointment booking, prescription requests, session history access, and secure messaging with providers</li>
            <li data-aos="zoom-in" data-aos-delay="550"><strong>Analytics Dashboard:</strong> Clinical insights showing patient progress, treatment adherence, outcome measurements, and operational metrics</li>
            <li data-aos="zoom-in" data-aos-delay="600"><strong>Mobile Accessibility:</strong> Responsive design enabling both clinicians and patients to access the platform from any device</li>
          </ul>

          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8 mt-8"
            data-aos="fade-down"
            data-aos-delay="650"
          >
            Results Achieved
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="700">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">45%</h5>
              <p className="text-[#9E9E9E]">Faster appointment scheduling and patient check-in</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="750">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">60%</h5>
              <p className="text-[#9E9E9E]">Improvement in clinical documentation accuracy</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="800">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">50%</h5>
              <p className="text-[#9E9E9E]">Increase in patient engagement and session attendance</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="850">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">99.9%</h5>
              <p className="text-[#9E9E9E]">Platform uptime serving thousands monthly</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="900">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">70%</h5>
              <p className="text-[#9E9E9E]">Reduction in administrative overhead for clinicians</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="950">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">100%</h5>
              <p className="text-[#9E9E9E]">HIPAA compliance with zero security breaches</p>
            </div>
          </div>

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed"
            data-aos="fade-up"
            data-aos-delay="1000"
          >
            The digital transformation enabled the clinic to scale operations, improve patient outcomes, and deliver
            accessible mental healthcare. Teleconsultation capabilities expanded their reach to underserved populations,
            while comprehensive digital records enhanced treatment continuity and clinical decision-making. The platform's
            success has positioned the clinic as a leader in digital mental health innovation.
          </p>
        </div>
      </div>
    </section>
  )
}

export default OurSolution